import { AddEmailParams, LandingPageDataType, LandingPageDraftDataType } from "../types";
import { axiosClient } from "./axiosClient";

// Publiczna strona zapisów (vox populi) — odczyt + zapis leada + potwierdzenie.
// Zarządzanie stronami zapisów (CRUD) zostało wycofane z nowego panelu —
// strona zapisów powstaje automatycznie przy głosowaniu z elektoratem „signup".

export const getLandingPage = async (id: string) =>
  axiosClient.get<LandingPageDataType | LandingPageDraftDataType>(`landing_pages/${id}`);

export const addEmail = async (id: string, params: AddEmailParams) =>
  axiosClient.post(`landing_pages/${id}/lead`, { lead: params });

export const confirmAddEmail = async (token: string) =>
  axiosClient.post("lead/confirm", {
    confirmation_token: token
  });
